import { Helpers } from "@/core/utils";
import { ref } from "vue";

export class Draft
{
    constructor( ctx )
    {
        this.store = ctx.store;
        this.trigger = ref(0);
    } 

    _getKey(uid)
    {
        let organizationId = sessionStorage.getItem('X-OrganizationID') || localStorage.getItem('X-OrganizationID');
        return organizationId ? `draft_${uid}_${organizationId}` : `draft_${uid}`;
    }

    get( uid ) 
    {
        this.trigger.value;

        let draft = Helpers.Storage( 'local', 'get', this._getKey(uid) );

        if( draft )
        {
            return JSON.parse( draft ); 
        }
    } 

    set( uid, data )
    {
        this.trigger.value++;
        return Helpers.Storage( 'local', 'set', this._getKey(uid), JSON.stringify( data ) );
    }

    remove( uid )
    {
        this.trigger.value++;
        return Helpers.Storage( 'local', 'remove', this._getKey(uid) );
    }
}